<script lang="ts" setup>
import { computed } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { ImService } from '../../im.service';

const service = useService(ImService);
</script>

<template>
  <div class="text-colorTextSecondary pt-2 text-center text-sm">
    <div v-if="!service.messageService.hasNext">-已经到顶啦-</div>
    <div v-else-if="service.messageService.loadError">加载失败</div>
    <div v-else>加载中...</div>
  </div>
</template>
